import React from "react";
import { Container } from "react-bootstrap";
import DataTableBase from "../../shared/DataTableBase";
import NewUser from "../../shared/users/NewUser";
import { DateFormat } from "../../Helper";
import PatientList from "./PatientList";

const PatientRegistration = () => {
  document.title = "Patient Registration";
  const columns = [
    {
      name: "Kapid Id",
      selector: (row) => row.user_kapid_id,
    },
    {
      name: "Code",
      selector: (row) => row.patient[0].bp_patient_code,
    },
    {
      name: "Name",
      selector: (row) => row.full_name,
    },
    {
      name: "DoB",
      selector: (row) => <DateFormat value={row.dob} />,
    },
    {
      name: "Gender",
      selector: (row) => row.gender,
    },
    {
      name: "Contact",
      selector: (row) => row.mobile,
    },
  ];

  const data = [
    {
      id: 1,
      title: "Beetlejuice",
      year: "1988",
    },
    {
      id: 2,
      title: "Ghostbusters",
      year: "1984",
    },
  ];

  return (
    <Container>
      <NewUser redirectTo={"patient"} title={"Patient"} />
      <PatientList />
    </Container>
  );
};

export default PatientRegistration;
